import {Component, Input, Output, forwardRef, EventEmitter, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';
import {DirectoryService} from '../../../services/directory.service';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'settings-amenity-restrictions-field',
    templateUrl: './settings-amenity-restrictions-field.component.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SettingsAmenityRestrictionsFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => SettingsAmenityRestrictionsFieldComponent), multi: true}
    ]
})
export class SettingsAmenityRestrictionsFieldComponent extends AbstractFieldClass implements OnInit {
    @Input('value') _value = [];
    @Input() title = '';
    @Input('selectValues') _selectValues = [];
    @Input() userId: number;
    @Output('reset') resetPhones: EventEmitter<any> = new EventEmitter<any>();

    constructor(public directoryService: DirectoryService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    apply(): void {
        if (!(/^[0-9]*$/.test(this.value.number)) || parseInt(this.value.number) < 1 || this.value.number == '0' || !this.value.number) {
            toastr.warning('Only Numbers are allowed for input field in restrictions and they must equal to one or more');
            return;
        }
        if(!this.value.selectValue) {
            toastr.warning('Select field must not be empty.');
            return;
        }
        super.apply();
    }


    validator(value: any): boolean {
        return undefined;
    }

    delete() {
        if(this.value.number && this.value.selectValue) {
            this.value.number = '';
            this.value.selectValue = '';
            super.apply();
        } else
            super.cancel();
    }

    cancel() {
        super.cancel();
    }

    getValueBasedOnSelectValues(): string {
        let string = '';
        this._selectValues.forEach(sv => {
            if(sv.name == this.value.selectValue)
                string = sv.displayName;
        });
        return string;
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/settings-amenity-restrictions-field/settings-amenity-restrictions-field.component.ts